import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { enqueueSnackbar } from 'notistack';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { useAddContactSupportMutation } from 'src/store/Reducer/contact';
import * as Yup from 'yup';


export default function ContactUsForm() {

    const {user} =  useSelector((state) => state.user) 


    const [sendContactData , {isLoading}] = useAddContactSupportMutation()

    const ContactUsSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        subject: Yup.string().required('Subject is required'),
        message: Yup.string().required('Message is required'),
    });


    const defaultValues = useMemo(()=>{
        return {
            name: user?.name || '',
            subject: '',
            message: '',
        }
    },[user])

    const methods = useForm({
        resolver: yupResolver(ContactUsSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (formData) => {
        try {
        const payload = {
            name: formData.name,
            email: user?.email || '',   
            subject: formData.subject,
            message: formData.message,
        }
        const response = await sendContactData(payload);
        if(!response?.error){  
        
            reset();
           return enqueueSnackbar(response?.data?.message	|| 'Message sent successfully', { variant: 'success' });
        }
        } catch (error) {
          console.error('error', error);
        
        }
    });

    const renderHead = (
        <Stack spacing={2} sx={{ m: 5 }}>
            <Typography variant="h4" textAlign={'center'}>Contact Support</Typography>
        </Stack>
    );

    const renderForm = (
        <Stack spacing={2.5}>
            <RHFTextField name="name" label="Name" InputProps={{ readOnly : true }}/>
            <RHFTextField name="subject" label="Subject" />
            <RHFTextField name="message" label="Message" multiline rows={4}/>
            
            <LoadingButton
                fullWidth
                color="inherit"
                size="large"
                type="submit"
                variant="contained"
                loading={isSubmitting || isLoading} 
            >
                Submit
            </LoadingButton>
        </Stack>
    );

    return (
        <Stack display='flex' justifyContent='center' alignItems={'center'}>
            <Stack sx={{
                width: {
                    xs: '90%',
                    lg: '50%',
                    md: '60%'
                }
            }}>
                <FormProvider methods={methods} onSubmit={onSubmit}>
                    {renderHead}
                    {renderForm}
                </FormProvider>
            </Stack>
        </Stack>
    );
}